import React from "react";
import { useLang } from "@/i18n";
import { Link } from "react-router-dom";
import { BRAND } from "@/config";

const IMG = "https://images.unsplash.com/photo-1674290844001-006bd2a9c51c?crop=entropy&cs=srgb&fm=jpg&q=85";

export default function AboutPage() {
  const { t, lang } = useLang();
  return (
    <div data-testid="about-page" className="pt-32 md:pt-40 pb-24">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 grid md:grid-cols-12 gap-14 items-start">
        <div className="md:col-span-6">
          <p className="eyebrow mb-5">{t("about.kicker")}</p>
          <h1 className="font-serif-hc font-light text-5xl md:text-7xl leading-[1.0] text-[#F5F2EA]">
            {t("about.title")}
          </h1>
          <p className="mt-8 text-[#A3A095] text-lg leading-relaxed">{t("about.body")}</p>
          <p className="mt-6 text-[#A3A095] text-lg leading-relaxed">{t("about.p2")}</p>

          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <Link to="/tours" className="hc-btn-primary">{t("tours.all")}</Link>
            <Link to="/contacto" className="hc-btn-secondary">{t("contact.cta")}</Link>
          </div>
        </div>

        <div className="md:col-span-6 md:col-start-8 space-y-4">
          <div className="aspect-[4/5] overflow-hidden">
            <img src={IMG} alt="" className="w-full h-full object-cover" />
          </div>
          <div className="flex items-center gap-4 pt-4">
            <img src={BRAND.logoUrl} alt="HC" className="h-12" />
            <p className="font-serif-hc italic text-[#C4A661] text-lg">{BRAND.name}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
